import ProductList from "../screen/purchase/product/ProductList";
import PageTemplate from "../components/common/PageTemplate";

const ProductListPage = () => {
  return <PageTemplate mainComponent={<ProductList />} noPadding={true} />;
};

export default ProductListPage;
